import type { BadgeTone } from '../lib/suivi-format';

/** Pastille de statut — vocabulaire normalisé (acquis / en cours / à revoir). */
export function Badge({ tone, label }: { tone: BadgeTone; label: string }) {
  return <span className={`badge badge--${tone}`}>{label}</span>;
}
